module.exports = __webpack_public_path__ + "media/images/lb/724-e599f71decdebe345f4f6ec48d3cd805.svg";